import { fromJS } from 'immutable';
import { resolveErrors } from '../../../../components/grid/resultGridUtils';
import { visibleColumns } from './tsunamiReduxConstants';


export const TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST = 'TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST';
export const TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_SUCCESS = 'TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_SUCCESS';
export const TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_FAILURE = 'TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_FAILURE';

export const TSUNAMI_EVENT_DATA_VALIDITY_REQUEST = 'TSUNAMI_EVENT_DATA_VALIDITY_REQUEST';
export const TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS = 'TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS';
export const TSUNAMI_EVENT_DATA_VALIDITY_FAILURE = 'TSUNAMI_EVENT_DATA_VALIDITY_FAILURE';

export const TSUNAMI_EVENT_DATA_REGION_REQUEST = 'TSUNAMI_EVENT_DATA_REGION_REQUEST';
export const TSUNAMI_EVENT_DATA_REGION_SUCCESS = 'TSUNAMI_EVENT_DATA_REGION_SUCCESS';
export const TSUNAMI_EVENT_DATA_REGION_FAILURE = 'TSUNAMI_EVENT_DATA_REGION_FAILURE';

export const TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST = 'TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST';
export const TSUNAMI_EVENT_DATA_RUNUP_REGION_SUCCESS = 'TSUNAMI_EVENT_DATA_RUNUP_REGION_SUCCESS';
export const TSUNAMI_EVENT_DATA_RUNUP_REGION_FAILURE = 'TSUNAMI_EVENT_DATA_RUNUP_REGION_FAILURE';

export const TSUNAMI_EVENT_DATA_CAUSE_REQUEST = 'TSUNAMI_EVENT_DATA_CAUSE_REQUEST';
export const TSUNAMI_EVENT_DATA_CAUSE_SUCCESS = 'TSUNAMI_EVENT_DATA_CAUSE_SUCCESS';
export const TSUNAMI_EVENT_DATA_CAUSE_FAILURE = 'TSUNAMI_EVENT_DATA_CAUSE_FAILURE';

export const TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST = 'TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST';
export const TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS = 'TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS';
export const TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE = 'TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE';

export const TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST = 'TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST';
export const TSUNAMI_EVENT_DATA_BULK_EDIT_SUCCESS = 'TSUNAMI_EVENT_DATA_BULK_EDIT_SUCCESS';
export const TSUNAMI_EVENT_DATA_BULK_EDIT_FAILURE = 'TSUNAMI_EVENT_DATA_BULK_EDIT_FAILURE';

export const TSUNAMI_DATA_CLEAR = 'TSUNAMI_DATA_CLEAR';

export const TSUNAMI_DATA_TOGGLE_COLUMN = 'TSUNAMI_DATA_TOGGLE_COLUMN';

export const TSUNAMI_EVENT_DATA_SAVE_OPEN_CONFIRMATION = 'TSUNAMI_EVENT_DATA_SAVE_OPEN_CONFIRMATION';
export const TSUNAMI_EVENT_DATA_SAVE_CANCEL_CONFIRMATION = 'TSUNAMI_EVENT_DATA_SAVE_CANCEL_CONFIRMATION';
export const TSUNAMI_EVENT_DATA_CANCEL_EDIT = 'TSUNAMI_EVENT_DATA_CANCEL_EDIT';
export const TSUNAMI_EVENT_DATA_EDIT = 'TSUNAMI_EVENT_DATA_EDIT';

const initialState = fromJS({
  deleting: false,
  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},

  fetchedRegions: false,
  regions: [],
  fetchedRunupRegions: false,
  runupRegions: [],
  fetchedRunupMeasurementTypes: false,
  runupMeasurementTypes: [],
  fetchedValidities: false,
  validities: [],
  fetchedCauses: false,
  causes: [],

  visibleColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiEventDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case TSUNAMI_EVENT_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case TSUNAMI_EVENT_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case TSUNAMI_EVENT_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case TSUNAMI_EVENT_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case TSUNAMI_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));

    case TSUNAMI_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case TSUNAMI_EVENT_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case TSUNAMI_EVENT_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));

    case TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST:
      return state.set('deleting', true);
    case TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_SUCCESS:
    case TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_FAILURE:
      return state.set('deleting', false);

    case TSUNAMI_EVENT_DATA_VALIDITY_REQUEST:
      return state.merge(fromJS({
        fetchedValidities: false,
      }));
    case TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        fetchedValidities: true,
        validities: action.response.items,
      }));
    case TSUNAMI_EVENT_DATA_VALIDITY_FAILURE:
      return state.merge(fromJS({
        fetchedValidities: true,
      }));

    case TSUNAMI_EVENT_DATA_CAUSE_REQUEST:
      return state.merge(fromJS({
        fetchedCauses: false,
      }));
    case TSUNAMI_EVENT_DATA_CAUSE_SUCCESS:
      return state.merge(fromJS({
        fetchedCauses: true,
        causes: action.response.items,
      }));
    case TSUNAMI_EVENT_DATA_CAUSE_FAILURE:
      return state.merge(fromJS({
        fetchedCauses: true,
      }));
    case TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: false,
      }));
    case TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
        runupMeasurementTypes: action.response.items,
      }));
    case TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        fetchedRunupMeasurementTypes: true,
      }));

    case TSUNAMI_EVENT_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case TSUNAMI_EVENT_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case TSUNAMI_EVENT_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRunupRegions: false,
      }));
    case TSUNAMI_EVENT_DATA_RUNUP_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
        runupRegions: action.response.items,
      }));
    case TSUNAMI_EVENT_DATA_RUNUP_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRunupRegions: true,
      }));

    default:
      return state;
  }
};
